import store from 'config/store'
import { receiveAgentMessage, setUnreadMessage } from 'modules/conversations/actions'
import { isMeetingScheduleMessage, orderMessages } from 'modules/message/utils'
import { toggleChat } from 'modules/view/actions'
import { Message } from 'types/message'
import EventBuffer from 'utils/eventBuffer'

const BUFFER_TIME_IN_MS = 1000

class AgentMessageEventBuffer extends EventBuffer<Message> {
  constructor() {
    super(BUFFER_TIME_IN_MS)
  }

  _publishBuffer = async () => {
    if (!this._events.length) {
      return
    }

    orderMessages(this._events).forEach(message => {
      this._dispatchAgentMessage(message)

      store.dispatch(
        setUnreadMessage({
          message
        })
      )
    })

    this._resetBuffer()
  }

  _shouldPublishImmediately = (message: Message) => (
    isMeetingScheduleMessage(message)
  )

  _openChatIfClosed = () => {
    const { chatOpen } = store.getState().view
    if (!chatOpen) {
      store.dispatch(toggleChat({ chatOpen: true }))
    }
  }

  _dispatchAgentMessage = (message: Message) => {
    store.dispatch(
      receiveAgentMessage({
        message
      })
    )
  }
}

export default new AgentMessageEventBuffer()
